import classNames from 'classnames'
import styles from './styles.module.scss'
import { createUseStyles } from 'react-jss'
import { getColor } from '../../../../assets/Js/modules/styles/styles.module'
import { Icon } from '../../../ui/icons/Icon'
import { Link } from 'react-router-dom'
import { useContext, useRef, useState } from 'react'
import {useSelector} from 'react-redux'
import { ADD_NEW_MESSAGE } from '../../../../redux/types';
import { Emojis } from '../../../ui/emojis/Emojis'
import { useFile } from '../../../hooks/useFile'
import { userAudioRecord } from '../../../hooks/audio-record/useAudioRecord'
import { Context } from '../../../../Context'
import { AppFetch } from '../../../../utils/app_module'

const colorBlue = getColor({name:'blue'})
const colorWhite = getColor({name:'white', type:'primary'})
const colorBlack = getColor({name:'black', type:'primary'})

const useStyles = createUseStyles({
  footer: {
    backgroundColor: colorBlue
  },
  footerControlBlock: {
    backgroundColor: colorWhite
  },
  sendMessageField: {
    caretColor: colorBlue,
    backgroundColor: 'transparent'
  },
  footerBottom: {
    color: colorWhite
  },
  footerBottomLink: {
    color: colorWhite
  },
  Webmaster: {
    color: colorWhite,

    footerBottomLink: {
      color: colorWhite,
    }
  }
})


export const Footer = ({typeDialog='p2p'}) => {
  const [showSendMessageBtn, setShowSendMessageBtn] = useState(false)
  const [showEmojis, setShowEmojis] = useState(false)
  const variablesReducer =  useSelector(state => state.variablesReducer)
  const clientDataReducer =  useSelector(state => state.clientDataReducer)
  const {useMessageHook} = useContext(Context)
  const {sendMessage} = useMessageHook

  console.log('clientDataReducer', clientDataReducer)

  const {sendFile} = useFile()
  const msgField = useRef()
  const fileField = useRef()
  const {panel, start} = userAudioRecord((opts) => {
    const {file, fileName, handlerRemoveRecoder} = opts
    sendFile({file, messageType:9}, (response) => {handlerRemoveRecoder()})
  })

  
  

  const handlerStartChooseFile = () => {
    fileField.current.click()
  }

  const handlerFocus = () => setShowSendMessageBtn(true)
  const handlerFocusout = e => {
    const msgField = e.target
    if(msgField) {
      const message = msgField.value.trim()
      if(message.length===0) setShowSendMessageBtn(false)
    }
  }
 
  const handlerSendMessage = () => {
    const field = msgField?.current
    if(field) {
      const message = field.value.trim()
      if(message?.length) {
        const msgOptions = {message}
        if(variablesReducer?.selectedMessageId) {
          const selectedMessageId = variablesReducer.selectedMessageId
          msgOptions.selectedMessageId = selectedMessageId
        }

        if(variablesReducer?.citationTextTarget) {
          msgOptions.citationTextTarget = variablesReducer.citationTextTarget
        }
        
        switch (typeDialog) {
          case 'p2p':
            sendMessage(msgOptions, (response) => {
              field.value = ''
              field.focus()
              if(showEmojis) setShowEmojis(false)
              field.value = ''
              field.focus()
            })
            break
          case 'group':
            const dialogId = 281
            console.log('typeDialog===>>>', typeDialog, message)
            const formData = new FormData()
            formData.append('action', 'send_message_dialog')
            formData.append('domain', clientDataReducer.site_info.domain)
            formData.append('text', message)
            formData.append('dialog_id', dialogId)
            formData.append('site_id', clientDataReducer.site_id)
            formData.append('part_id', clientDataReducer.key)
            formData.append('part_site_id', clientDataReducer.site_id)
            formData.append('messageType', 0)
            formData.append('clientType', 'client')
            formData.append('name', '')
            formData.append('key', clientDataReducer.key)
            formData.append('type', 1)
            formData.append('channel', clientDataReducer.channel)
            formData.append('where', 'to_fms')
            
            const xhr = AppFetch(`${callpy_global.php_server}d`, {
              method: 'POST',
              body: formData
            })

            break
        

        }



        // action: send_message_dialog
        // domain: prestashop.demo.callpy.com
        // text: сообщение в групповой диалог
        // dialog_id: 287
        // part_id: 1464
        // part_site_id: 17859
        // clientType: client
        // messageType: 0
        // name: 
        // site_id: 17859
        // key: 1464
        // type: 1
        // channel: 340ad047cf166911fee7502d8f1fe1a3
        // where: to_fms

        
      }
    }
  }

 

  const handlerKeyDow = e => {
    if(e.key==='Enter') {
      handlerSendMessage()
    }
  }

  const handlerSelectEmoji = (item) => {
    const field = msgField?.current
    if(item&&field) {
      const currentValue = field.value
      field.value = currentValue.concat(' ', item.emoji)
      field.focus()
    }
  }

  
  const handlerFileFieldChanged = e => {
    const field = e.target
    if(field) {
      const file = field.files[0]
      //console.log('selected File', file)
      if(file) {
        sendFile({file}, (response) => {})
      }
    }
  }

  const handlerAudioStartRecord = e => {
    start({btn:e.currentTarget})
  }



  
  const classes = useStyles()
  return (
    <div className={classNames(styles.footer, classes.footer)}>
      <div className={classNames(styles.footerInner)}>
        {showEmojis&&<Emojis className={classNames(styles.Chatemojis)} onSelect={(response)=> handlerSelectEmoji(response)}/>}
        <div className={classNames(styles.footerControlBlock, classes.footerControlBlock)}>
          <button className={classNames(styles.emojisBtn)} onClick={()=>setShowEmojis(currentValue => !currentValue)}><Icon name='smile'/></button>
          <input  
            className={classNames(styles.sendMessageField, classes.sendMessageField)} 
            placeholder='ввод сообщения' 
            ref={msgField} 
            onFocus={handlerFocus} 
            onBlur={handlerFocusout}
            onKeyDown = {handlerKeyDow}
          />
          <input 
            type="file" 
            name="file" 
            className={classNames(styles.fileField)} 
            ref={fileField}
            onChange={handlerFileFieldChanged}
          />
          <div className={classNames(styles.footerControlBlockActions)}>
            <button className={classNames(styles.attachmentBtn)} onClick={handlerStartChooseFile}><Icon name='attachment'/></button>
            {showSendMessageBtn&&<button className={classNames(styles.sendBtn)} onClick={handlerSendMessage}><Icon name='send' bg={colorBlue}/></button>}
            {!showSendMessageBtn&&<button className={classNames(styles.sendBtn)} onMouseDown={handlerAudioStartRecord}><Icon name='microphone'/></button>}
            {panel}
          </div>
        </div>
        <div className={classNames(styles.footerBottom, classes.footerBottom)}>
          <span  className={classNames(styles.footerBottomWebmaster)}>Разработано в <Link to='#' className={classNames(styles.footerBottomLink, classes.footerBottomLink)}>Callpy</Link></span>
          <Link  className={classNames(styles.footerBottomLink, classes.footerBottomLink)} to='#'>Политика конфеденциальности</Link>
        </div>
      </div>
    </div>
  )
}
